import React from "react";
import { images } from "../constants";

import { useTranslation } from "react-i18next";

import { enableScroll, disableScroll } from "../utils/scrollFuncions";

const Popup = ({handleClose, comicLink}) => {

  const { t } = useTranslation();

  // Disable scrolling
  disableScroll();

  const closePopup = () => {
    enableScroll();
    handleClose();
  };

  // Copy the link of the comic
  // https://www.geeksforgeeks.org/how-to-create-copy-to-clipboard-button/
  function copyComicLink(comicLink) {
    navigator.clipboard.writeText(comicLink);
  }

  console.log(encodeURIComponent("https://www.honkypie.com/"))
  console.log(encodeURIComponent(comicLink))

  const normalURL = "https://www.honkypie.com/"
  const facebookURL = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(normalURL) + "&amp;src=sdkpreparse";
  const xURL = "https://twitter.com/intent/tweet?text=" + encodeURIComponent("A Honky Pie Comic: ")  + "&url=" + encodeURIComponent(normalURL);
  const reeditUrl = "https://reddit.com/submit?title=" + encodeURIComponent("A Honky Pie Comic") + "&url=" + encodeURIComponent(normalURL);




  // https://stackoverflow.com/questions/59017954/react-close-modal-on-click-outside - Para hacer que el Popup se cierre cuando se haga click afuera de la ventana.s
  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-70 justify-center items-center" onClick={closePopup}>

      <div className="flex justify-center items-center h-full w-full">
        
        <div className="flex flex-col items-center bg-white rounded-lg p-6 max-w-lg fade-in modal-content z-50 space-y-7" onClick={e => e.stopPropagation()}>
          
          <ul className="flex space-x-16 md:justify-start">
              <li>
                <div class="fb-share-button" data-href={normalURL} data-layout="" data-size="">
                  <a target="_blank" href={facebookURL} class="fb-xfbml-parse-ignore">
                    <img className="w-16" src={images.FacebookSquareIcon} alt="" />
                  </a>
                </div>
              </li>
              <li>
                <a class="twitter-share-button" href={xURL}>
                  <img className="w-16" href={xURL} src={images.XSquareIcon} alt="" />
                </a>
              </li>
              <li>
                <a href={reeditUrl} onclick="window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');return false;" title="Share on Reddit" rel="noopener" >
                  <img className="w-16" src={images.RedditSquareIcon} alt="" />
                </a>
              </li>
          </ul>
          <button className="font-bold w-auto text-2xl" onClick={() => copyComicLink(comicLink)}>{t('Copy Link')}</button>
          <button className="bg-blue-500 text-white px-4 py-2 rounded font-bold w-auto" onClick={closePopup}>{t('CLOSE')}</button>
          
        </div>

      </div>
    </div>
  );
};
            
export default Popup;